import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('discardConversationsOption')(function discardConversationsOption(state) {
    var optionState = state.optionState;
    optionState.globalListViewType = null;
    optionState.conversationSortOrder = null;
    optionState.hideDeletedItems = null;
}));
//# sourceMappingURL=discardConversationsOption.js.map